import React, { useEffect, useRef, useCallback } from 'react';
import PropTypes from 'prop-types';
import fscreen from 'fscreen';

function Fullscreen({ enabled, onChange, children }) {
  const element = useRef(null);

  const isFullScreen = () => fscreen.fullscreenElement === element.current;

  const onFullScreenChange = useCallback(() => {
    if (onChange) onChange(isFullScreen());
  }, [onChange]);

  useEffect(() => {
    fscreen.addEventListener('fullscreenchange', onFullScreenChange);
    return () => {
      fscreen.removeEventListener('fullscreenchange', onFullScreenChange);
    };
    // NOTE: needs to run once on load
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const isFullScreenMode = isFullScreen();
    if (isFullScreenMode && !enabled) {
      if (fscreen.fullscreenEnabled) {
        fscreen.exitFullscreen();
      }
    } else if (!isFullScreenMode && enabled) {
      if (fscreen.fullscreenEnabled) {
        fscreen.requestFullscreen(element.current);
      }
    }
  }, [enabled]);

  return (
    <div
      style={{
        margin: 0,
        padding: 0,
        width: '100%',
        height: '100%',
      }}
      ref={element}
    >
      {children}
    </div>
  );
}

Fullscreen.propTypes = {
  enabled: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Fullscreen;
